import React from 'react';
import { t } from '@bay-email/core';
import { Image as ImagePanel } from '../Image';

export function DynamicImage() {
	return (
		<ImagePanel
			forceMode='dynamic'
			hideModeToggle
			contentHeader={t('Dynamic Content')}
		/>
	);
}
